import { Popup } from 'react-map-gl/mapbox'
import { Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import type { PopoverInfo } from '../../types'
import { startCase } from 'lodash'
import { PopoverRow } from './PoiPopover'

export function DriverPopover({ hoverInfo }: { hoverInfo: PopoverInfo | null }) {
  if (!hoverInfo || hoverInfo.popoverType !== 'driver') {
    return null // Don't render if hoverInfo is null or not a driver popover
  }

  return (
    <Popup
      latitude={hoverInfo.lat}
      longitude={hoverInfo.lon}
      closeButton={false}
      closeOnClick={false}
      anchor='bottom'
      offset={[0, -18]} // Offset to position correctly above the marker
      style={{ minWidth: '200px' }}
      className='mapbox-popover'
    >
      <Vertical gap={4}>
        <Texto category='h4' appearance='hint'>
          Driver
        </Texto>
        <PopoverRow label='Name' value={hoverInfo.driverName} category='h5' />

        <PopoverRow label='Status' value={startCase(hoverInfo.action) || 'Not Started'} category='h5' />
        {hoverInfo.orderNumber && <PopoverRow label='Curr. Order' value={hoverInfo.orderNumber} />}

        {hoverInfo.eta && (
          <Vertical>
            <PopoverRow label='ETA' value={formatters.TIME(hoverInfo.eta, hoverInfo.timezone)} />
            <PopoverRow label='As Of' value={formatters.DATE_TIME(hoverInfo.lastHeartbeat, hoverInfo.timezone)} />
          </Vertical>
        )}
      </Vertical>
    </Popup>
  )
}
